export const contactUsConstants = {
  GET_CONTACT_US_DATA_FAILURE: "GET_CONTACT_US_DATA_FAILURE",
  GET_CONTACT_US_DATA_SUCCESS: "GET_CONTACT_US_DATA_SUCCESS",

  ADD_CONTACT_DATA_FAILURE: "ADD_CONTACT_DATA_FAILURE",
  ADD_CONTACT_DATA_SUCCESS: "ADD_CONTACT_DATA_SUCCESS",
};
